import React, { useEffect, useState } from "react";
import InfoWindow from "./InfoWindow";

const InfoWindows = ({
  markersRef,
  updateInfoWindows,
  setUpdateInfoWindows,
}) => {
  const clickTarget = (e) => {};

  const onClose = (e, item) => {
    item.trackedItem.showInfo = false;
  };

  if (updateInfoWindows === true) {
    setUpdateInfoWindows(false);
  }

  return (
    <React.Fragment>
      {markersRef &&
        markersRef.current &&
        markersRef.current
          .values()
          .toArray()
          .map((marker) => {
            if (
              marker &&
              marker.trackedItem &&
              marker.trackedItem.showInfo === true
            ) {
              return (
                <InfoWindow
                  key={marker.trackedItem.id}
                  clickTarget={clickTarget}
                  marker={marker}
                  item={{
                    lastPosition: marker.trackedItem,
                    type: marker.trackedItem.type,
                  }}
                  onClose={(e) => onClose(e, marker)}
                />
              );
            }
            return null;
          })}
    </React.Fragment>
  );
};

export default InfoWindows;
